"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    labelColor: palette.tLabel,
    labelFontSize: palette.tsSmall,
    labelLineHeight: palette.tlSmall,
    labelMarginBottom: palette.gutter / 2 + 'px',
    radioItemMarginBottom: palette.gutter + 'px'
  };
}